module.exports = __webpack_public_path__ + "img/collect-circle-icon.8e90ae67.png";